// extracted by mini-css-extract-plugin
export default {"filtersRow":"Schedule_filtersRow__UZVno","tableBox":"Schedule_tableBox__eC0gl"};